import { gameSequenceKeys } from '@/hooks/tie-breaker/gameSequenceKeys';
import { getGameSequencesInfo } from '@/infrastructure/network/data/tie-breaker';
import { useQuery } from '@tanstack/react-query';

export const useGameSequenceInfoQuery = (matchId: string, gameNumber: number) => {
	return useQuery({
		queryKey: gameSequenceKeys.gameSequenceInfo(matchId),
		queryFn: () => getGameSequencesInfo({ matchUuid: matchId, gameNumber }),
		enabled: !!matchId && !!gameNumber
	});
};
